import { useEffect } from "react";
import ReactDOMServer from "react-dom/server";
import { useSelector } from "react-redux";
import PdfTemplate3 from "../template3";
import PdfTemplate4 from "../template4";
import PdfTemplate5 from "../template5";
import PdfTemplate6 from "../template6";
import PdfTemplate7 from "../template7";
import PdfTemplate9 from "../template9";
import PdfTemplate10 from "../template10";
import PdfTemplate11 from "../template11";
function useGetTemplate() {
  const { userInfo } = useSelector((state: any) => state?.userInfo);
  const { selectCustomer } = useSelector((state: any) => state?.userInfo);
  useEffect(() => {
    localStorage.setItem(
      "templates",
      JSON.stringify([
        {
          id: 0,
          component: <PdfTemplate3 userInfo={userInfo} />,
          title: "پیش کرایه",
          html: ReactDOMServer.renderToString(<PdfTemplate3 />),
          // printGroup: { id: 0, text: 'سفارش' },
          isDefault: selectCustomer?.printTemplate === 0,
          // isDefault:
          //   selectCustomer?.printTemplate === null ||
          //   selectCustomer?.printTemplate === 0,
        },
        {
          id: 1,
          component: <PdfTemplate4 userInfo={userInfo} />,
          title: "مرسوله  پس کرایه و پرداخت در محل 1  ",
          isDefault: selectCustomer?.printTemplate === 1,
          // printGroup: { id: 0, text: 'سفارش' },
          html: ReactDOMServer.renderToString(<PdfTemplate4 />),
        },
        {
          id: 2,
          component: <PdfTemplate5 userInfo={userInfo} />,
          title: "مرسوله  پس کرایه و پرداخت در محل 2  ",
          isDefault: selectCustomer?.printTemplate === 2,
          // printGroup: { id: 0, text: 'سفارش' },
          html: ReactDOMServer.renderToString(<PdfTemplate5 />),
        },
        {
          id: 3,
          component: <PdfTemplate6 userInfo={userInfo} />,
          title: "مرسوله  پس کرایه و پرداخت در محل 3  ",
          isDefault: selectCustomer?.printTemplate === 3,
          // printGroup: { id: 0, text: 'سفارش' },
          html: ReactDOMServer.renderToString(<PdfTemplate6 />),
        },
        {
          id: 4,
          component: <PdfTemplate7 userInfo={userInfo} />,
          title: "مرسوله 4  ",
          isDefault: selectCustomer?.printTemplate === 4,
          // printGroup: { id: 0, text: 'سفارش' },
          html: ReactDOMServer.renderToString(
            <PdfTemplate7 userInfo={userInfo} />
          ),
        },
        // {
        //   id: 5,
        //   component: <PdfTemplate8 userInfo={userInfo} />,
        //   title: 'مرسوله  پس کرایه و پرداخت در محل 3  ',
        //   isDefault: selectCustomer?.printTemplate === 5,
        //   // printGroup: { id: 0, text: 'سفارش' },
        //   html: ReactDOMServer.renderToString(<PdfTemplate8 userInfo={userInfo} />),
        // },
        {
          id: 6,
          component: <PdfTemplate9 userInfo={userInfo} />,
          title: "مرسوله  5  ",
          isDefault: selectCustomer?.printTemplate === 6,
          // printGroup: { id: 0, text: 'سفارش' },
          html: ReactDOMServer.renderToString(
            <PdfTemplate9 userInfo={userInfo} />
          ),
        },
        {
          id: 7,
          component: <PdfTemplate10 userInfo={userInfo} />,
          title: "مرسوله  6  ",
          isDefault: selectCustomer?.printTemplate === 7,
          // printGroup: { id: 0, text: 'سفارش' },
          html: ReactDOMServer.renderToString(
            <PdfTemplate10 userInfo={userInfo} />
          ),
        },
        {
          id: 8,
          component: <PdfTemplate11 userInfo={userInfo} />,
          title: "مرسوله  7  ",
          isDefault:
            selectCustomer?.printTemplate === null ||
            selectCustomer?.printTemplate === 8,
          // printGroup: { id: 0, text: 'سفارش' },
          html: ReactDOMServer.renderToString(
            <PdfTemplate11 userInfo={userInfo} />
          ),
        },
      ])
    );
  }, [selectCustomer?.printTemplate]);
}

export default useGetTemplate;
